import { useHasBoxDraft } from "../lib/boxDraft";

/** A dot beside a box's name while this browser holds an unsaved draft of it. */
export function UnsavedDraftDot({ boxId }: { boxId: string }) {
  const hasDraft = useHasBoxDraft(boxId);
  if (!hasDraft) return null;
  return (
    <span
      className="ml-2 inline-block size-2 rounded-full bg-amber-400 align-middle"
      title="Unsaved draft in this browser"
    >
      <span className="sr-only">Unsaved draft</span>
    </span>
  );
}
